import { BrowserRouter, Routes, Route } from "react-router-dom";
import ViewerApp from "./ViewerApp";
import AdminApp from "./admin/App";
import LandingPage from "./pages/LandingPage";
// import { AccountProvider } from "./context/AccountContext";
// import LoginPage from "./pages/LoginPage";
{/* <Route path="/driver/:driver_id/:entity_id/:sub_entity_id" element={<ViewerApp />} /> */}
export default function RootApp() {

    return (
        // <AccountProvider>
        <BrowserRouter>
                <Routes>
                    {/* <Route path="/" element={<LoginPage />} /> */}
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/viewer" element={<ViewerApp />} />
                    <Route path="/admin/*" element={<AdminApp />} />
                </Routes>
        </BrowserRouter>
        // </AccountProvider> 
    );
}

